import React from "react";

const DashboardTabItem = props => {
  const {
    name = "",
    isActive = false,
    isDefault = false,
    isMenuOpen = false,
    onClick = () => {},
    onMenuClick = () => {},
    tabRef = () => {}
  } = props;

  return (
    <div
      ref={tabRef}
      className={`dashboardV2Tab${isActive ? " dashboardV2TabActive" : ""}`}
      onClick={onClick}
      role="tab"
    >
      <span className="dashboardV2TabName" title={name}>{name}</span>
      {!isDefault && (
        <button
          type="button"
          className={`dashboardV2TabDotMenuBtn${isMenuOpen ? " dashboardV2TabDotMenuBtnOpen" : ""}`}
          onClick={e => {
            e.stopPropagation();
            onMenuClick();
          }}
          title="Dashboard options"
        >
          ⋮
        </button>
      )}
    </div>
  );
};

export default DashboardTabItem;
